import { tt } from "../i18n/i18n";

export const buildDisplayNameForSource = (str: string | null | undefined) => {
  const utmCampaign = str?.split(";")?.[0];
  const utmMedium = str?.split(";")?.[1];
  const utmSource = str?.split(";")?.[2];

  if (!utmCampaign) {
    if (utmMedium === "takeaway" && utmSource === "qrcode") {
      return tt("posa_takeaway");
    } else if (!utmMedium && utmSource === "qrcode") {
      return tt("posa_onsite");
    }
  }

  let arrRes: string[] = [];

  if (utmCampaign) {
    arrRes.push(buildDisplayNameForComponentOfSource(utmCampaign));
  }

  if (utmMedium) {
    arrRes.push(buildDisplayNameForComponentOfSource(utmMedium));
  }

  if (utmSource) {
    arrRes.push(buildDisplayNameForComponentOfSource(utmSource));
  }

  if (
    arrRes?.[0] === tt("automated_email") &&
    arrRes?.[1] === tt("automated_email")
  ) {
    arrRes = [tt("automated_email")];
  }

  arrRes = arrRes.filter((e) => !!e);

  if (arrRes.length === 0) {
    return tt("uncategorized");
  }

  return arrRes.join(" - ");
};

export const buildDisplayNameForComponentOfSource = (
  comp: string | null | undefined
) => {
  if (!comp) {
    return "";
  }

  const val = MAP[comp];

  if (val === undefined || val === null) {
    return "";
  }

  if (val === "") {
    return comp;
  }

  return val;
};

const MAP: Record<string, string | null> = {
  "20230907_Lipton_Lancement": "",
  "20230927 - LiptonUltimeV2": "",
  "20231024-PepsiBudapest": "",
  "20231909 - Lipton Relance": "",
  ApparenceGesipo_Jeu24: "",
  ApparenceHolt_Jeu24: "",
  ApparenceTruch_Jeu24: "",
  "PEPSI-BUDAPEST-V4": "",
  acq: "",
  afficheA4: tt("utm_source_a4_poster"),
  décembre23B2C: "",
  email_4_digit_code: tt("automated_email"), // tt("utm_source_4_digit_code_email"),
  email_onboarding: tt("automated_email"), // tt("utm_source_welcome_email_day_3"),
  game: tt("utm_source_game"),
  game_expiry: tt("automated_email"), // tt("utm_source_expired_coupon"),
  game_won_email: tt("automated_email"), // tt("utm_source_gift_won"),
  grant_tokens_150th: tt("automated_email"), // tt("utm_source_tokens_offered_15th"),
  grant_tokens_15th: tt("automated_email"), // tt("utm_source_tokens_offered_15th"),
  highlight_balloon_blast: tt("automated_email"), // tt("utm_source_balloon_pop_event"),
  highlight_halloween_2024: tt("automated_email"), // tt("utm_source_halloween_event"),
  highlight_wordle: tt("automated_email"), // tt("utm_source_wordle_event"),
  ml_loser: tt("automated_email"), // tt("utm_source_big_prize_defeat"),
  ml_loser_v2: tt("automated_email"), // tt("utm_source_big_prize_defeat"),
  ml_reminder: tt("automated_email"), // tt("utm_source_big_prize_reminder"),
  novembre23B2C: "",
  ocr_manual_validation: tt("automated_email"), // tt("utm_source_manual_photo_validation"),
  partage: "",
  prognosis: tt("utm_source_forecast_confirmation"),
  prognosis_canceled: tt("utm_source_forecast_cancellation"),
  prognosis_daily: tt("utm_source_forecast_result"),
  redeem: tt("utm_source_gift_retrieved"),
  relance_fondation_2025_02_06: "",
  relance_fondation_2025_02_09: "",
  share: tt("utm_source_share"),
  sponsoree_redeem_email: tt("automated_email"), // tt("utm_source_wom_referral_retrieves"),
  sponsoree_wins_email: tt("automated_email"), // tt("utm_source_wom_referral_plays"),
  stickers: tt("utm_stickers"),
  stickers10x10: tt("utm_stickers"),
  test: "",
  tombola: tt("automated_email"), // tt("utm_source_lottery_ticket_won_email"),
  SMS: tt("utm_source_sms"),
  "e-mail": tt("automated_email"), // tt("utm_source_email"),
  email: tt("automated_email"), // tt("utm_source_email"),
  newsletter: tt("utm_source_newsletter"),
  qrcode: tt("utm_source_qr_code"),
  "t=fw": "",
  take: tt("utm_source_takeaway"),
  takeaay: tt("utm_source_takeaway"),
  takeaw: tt("utm_source_takeaway"),
  takeawa: tt("utm_source_takeaway"),
  takeawan: tt("utm_source_takeaway"),
  takeaway: tt("utm_source_takeaway"),
  "takeaway ok": tt("utm_source_takeaway"),
  "takeaway.": tt("utm_source_takeaway"),
  takeawayad: tt("utm_source_takeaway"),
  takeawaye: tt("utm_source_takeaway"),
  "takeawayhttps://g.kadow.club/?venueId=624ab3590231da0fa21707e6":
    "A emporter",
  "takeawayhttps://g.kadow.club/?venueId=6351607b5a832f591653a38b":
    "A emporter",
  "takeawayhttps://g.kadow.club/?venueId=63d7c32604d8937b77ad3a94":
    "A emporter",
  "takeawayhttps://g.kadow.club/?venueId=65a79f176e26611cbe2ca708":
    "A emporter",
  "takeawayhttps://g.kadow.club?venueId=655e2c630a3ec9539c846e8c": "A emporter",
  takewa: "A emporter",
  takeway: "A emporter",
  "takewayRegarde ce QR Code grâce à cette magnifique application : https://itunes.apple.com/app/id1200318119":
    "A emporter",
  takewaym: "A emporter",
  "10_flyer_custom_poc": tt("utm_source_flyer"),
  AfficheA3: tt("utm_source_a3_poster"),
  Boite_a_pizza: tt("utm_source_pizza_box"),
  Flyers_A6: tt("utm_source_a6_flyer"),
  Reseaux_sociaux: tt("utm_source_social_media"),
  SPLIO: "",
  Test: tt("utm_source_test"),
  Whatsapp: tt("utm_source_whatsapp"),
  affi: tt("utm_source_poster"),
  affiche: tt("utm_source_poster"),
  affiche_a: tt("utm_source_poster"),
  affiche_a0: tt("utm_source_poster"),
  affiche_a1: tt("utm_source_poster"),
  affiche_a2: tt("utm_source_poster"),
  affiche_a3: tt("utm_source_a3_poster"),
  affiche_a4: tt("utm_source_a4_poster"),
  affiche_a4_autocollante: tt("utm_source_a4_poster"),
  bache: tt("utm_source_banner"),
  borne: tt("utm_source_terminal"),
  carte_de_visite: tt("utm_source_business_card"),
  chevalet_a: tt("utm_source_easel"),
  chevalet_a4: tt("utm_source_easel"),
  chevalet_a6_format_portrait: tt("utm_source_easel"),
  chevalet_a6_portrait: tt("utm_source_easel"),
  ecran: tt("utm_source_screen"),
  encart: tt("utm_source_insert"),
  facebook: tt("utm_source_facebook"),
  flyer: tt("utm_source_flyer"),
  flyer_: "Flyer",
  flyer_a: "Flyer",
  flyer_a1: "Flyer A1",
  flyer_a2: "Flyer A2",
  flyer_a5: "Flyer A5",
  flyer_a6: "Flyer A6",
  flyer_a6_100pc_gagnant: "Flyer A6",
  flyer_a6_acq: "Flyer A6",
  flyer_a7: "Flyer A7",
  flyer_a9: "Flyer A9",
  flyer_b1: "Flyer B1",
  flyer_b2: "Flyer B2",
  flyer_b9: "Flyer B9",
  flyer_c10: "Flyer C10",
  flyer_c2: "Flyer C2",
  flyer_c7: "Flyer C7",
  flyer_f9: "Flyer F9",
  flyer_k2: "Flyer K2",
  flyer_k5: "Flyer K5",
  flyer_l2: "Flyer L2",
  flyer_n2: "Flyer N2",
  flyer_x0: "Flyer X0",
  flyer_x8: "Flyer X8",
  flyer_y3: "Flyer Y3",
  flyer_z0: "Flyer Z0",
  impression_sur_sac: "Impression sur sac",
  impressionbtepizza: "Boîte à pizza",
  insta: tt("utm_source_instagram"),
  instagram: tt("utm_source_instagram"),
  instastory: tt("utm_source_instagram_story"),
  kadow_fid: "",
  kakemono: tt("utm_source_banner_stand"),
  mktgauto: tt("automated_email"),
  perdants_glp_dec_2023: "",
  qrco: tt("utm_source_qr_code"),
  qrcod: tt("utm_source_qr_code"),
  "qrcode if": tt("utm_source_qr_code"),
  "qrcode.": tt("utm_source_qr_code"),
  "qrcode>=pr": tt("utm_source_qr_code"),
  "qrcodehttps://g.kadow.club?venueId=6603e3f4d5984264ea2e2cdb":
    tt("utm_source_qr_code"),
  qrcodep: tt("utm_source_qr_code"),
  sea: tt("utm_source_sea"),
  set_de_table: tt("utm_source_placemat"),
  table_set: tt("utm_source_placemat"),
  site_web: tt("utm_source_website"),
  sous_verre: tt("utm_source_coaster"),
  "sticker.s_classiques_10x10": tt("utm_source_classic_stickers"),
  stickers_5x5: tt("utm_source_classic_stickers"),
  stickers_classiques_: tt("utm_source_classic_stickers"),
  stickers_classiques_1010: tt("utm_source_classic_stickers"),
  stickers_classiques_10x1: tt("utm_source_classic_stickers"),
  stickers_classiques_10x10: tt("utm_source_classic_stickers"),
  "stickers_classiques_10x10>=fw": tt("utm_source_classic_stickers"),
  "stickers_classiques_10×10": tt("utm_source_classic_stickers"),
  stickers_classiques_8x8_sa: tt("utm_source_classic_stickers"),
  stickers_dome: tt("utm_source_dome_stickers"),
  stickers_pellicules: tt("utm_source_laminated_stickers"),
  stickers_pome: "",
  vitrophanie: tt("utm_source_window_decal")
};
